import React, { useEffect, useState, useRef } from 'react';
import GptService from '../Services/GptService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faLightbulb } from '@fortawesome/free-regular-svg-icons';


export default function ReactRTE({ gpt, gptOthers, value, setValue, name }) {
	let editorRef = useRef();
	const { CKEditor, Editor } = editorRef.current || {}; // if it don't find any document then it will be an empty object

	let [loaded, setLoaded] = useState(false);
	const [localDisabled, setLocalDisabled] = useState(false);

	useEffect(() => {
		editorRef.current = {
			CKEditor: require('@ckeditor/ckeditor5-react').CKEditor, // v3+
			Editor: require('ckeditor/build/ckeditor').Editor
		};
		setLoaded(true);
	}, []); // run on mounting

	const onGptClick = () => {
		setLocalDisabled(true)
		GptService.query(GptService.getChatGpt(gpt, value, gptOthers)).then(t => {
			setLocalDisabled(false);
			setValue(name, t[0]['message']['content']);
		}).catch(e => {
			setLocalDisabled(false);
		})
	}

	if (loaded) {
		return (
			<div className="CKEDITOR">
				<div className="flex items-center">
					<CKEditor
						editor={Editor}
						data={value}
						config={{
							toolbar: [
								'heading',
								'|', 'alignment', 'bold', 'italic', 'fontColor', 'fontBackgroundColor', 'fontSize',
								'|', 'blockQuote', 'link',
								'|', 'numberedList', 'bulletedList',
								'|', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells',
								"|", 'undo', 'redo',
								'|', 'htmlEmbed'
							],
							link: {
								decorators: [
									{
										mode: 'manual',
										label: 'Open in New Tab',
										attributes: {
											target: '_blank',
										}
									}
								]
							},
							heading: {
								options: [
									{
										model: 'paragraph',
										title: 'Paragraph',
										class: 'ck-heading_paragraph'
									},
									{
										model: 'heading1',
										view: 'h1',
										title: 'Heading 1',
										class: 'ck-heading_heading1'
									},
									{
										model: 'heading2',
										view: 'h2',
										title: 'Heading 2',
										class: 'ck-heading_heading2'
									},
									{
										model: 'heading3',
										view: 'h3',
										title: 'Heading 3',
										class: 'ck-heading_heading3'
									},
									{
										model: 'heading4',
										view: 'h4',
										title: 'Heading 4',
										class: 'ck-heading_heading4'
									},
									{
										model: 'heading5',
										view: 'h5',
										title: 'Heading 5',
										class: 'ck-heading_heading5'
									}
								]
							},
						}}
						onReady={(editor) => {
							// You can store the "editor" and use when it is needed.
							console.log('Editor is ready to use!', editor);
						}}
						onChange={(event, editor) => {
							// do something when editor's content changed
							const data = editor.getData();
							setValue(name, data);
						}}
						onBlur={(event, editor) => {
							console.log('Blur.', editor);
						}}
						onFocus={(event, editor) => {
							console.log('Focus.', editor);
						}}
					/>
					{gpt && <div onClick={onGptClick} className="ml-2 inline-flex items-center justify-center p-2 bg-yellow-400 rounded-full text-gray-800">
						{localDisabled ? <FontAwesomeIcon icon={faSpinner} spin /> : <FontAwesomeIcon icon={faLightbulb} />}
					</div>}
				</div>
			</div>
		);
	}
}
